/*eslint-disable */

import {bus} from '@/main';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery');
export default {
  name: 'email-update-popup',
  components: {},
  props: ['userEmail'],
  data () {
    return {
      otpVerifyPopupShow:false,
      email:'',
      fullOTP:''
    }
  },
  computed: {

  },
  mounted () {
    this.email = this.userEmail
  },
  methods: {
    getUserDetailsAgain() {
      this.$store.dispatch('fetchCurrentUserInfo')
    },
    validateBeforeEmailSubmit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$store.dispatch('optToEmailFun', {
            email:this.email,
          })
            .then((res) => {
              this.otpVerifyPopupShow = true;
              toast.success(res.data.msg || res.data.user_msg);
            }).catch((err) => {
              toast.error(err.data.data|| err.data.msg);
            })
          return;
        }
      });
    },
    validateBeforeEmailVerifySubmit(){
      this.$validator.validate().then((result) => {
        if (result) {
          this.$store.dispatch('verifiedEmailOfProfileFun', {
            email:this.email,
            otp: this.fullOTP,
          })
            .then((res) => {
                this.otpVerifyPopupShow = false;
                this.fullOTP = ''
                this.getUserDetailsAgain()
                this.updatedProfileEmailPopupClosed()
                toast.success(res.data.msg || res.data.user_msg);
            }).catch((err) => {
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      });
    },
    updatedProfileEmailPopupClosed(){
      bus.$emit('emailUpdatePopupStateBus', false)
      $('body').removeClass('mobileNoupdatePopup')
    }
  }
}


